import React, { useState, useEffect } from 'react';
import { X, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cookieService } from '../services/cookieService';

const CookieBanner: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [preferences, setPreferences] = useState({
    technical: true,
    analytics: false,
    advertising: false
  });

  useEffect(() => {
    const consentStatus = cookieService.getConsentStatus();
    if (!consentStatus) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    cookieService.savePreferences(preferences);
    setShowBanner(false);
  };

  const declineCookies = () => {
    cookieService.declineAll();
    setShowBanner(false);
  };

  const openCookieSettings = () => {
    setShowDetails(true);
  };

  const handlePreferenceChange = (category: keyof typeof preferences) => {
    setPreferences(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const savePreferences = () => {
    cookieService.savePreferences(preferences);
    setShowDetails(false);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-50 ${showBanner ? 'block' : 'hidden'}`}>
      <div className="bg-stone-200 dark:bg-gray-800 border-t border-stone-200 dark:border-gray-700 p-4">
        <div className="container mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="text-stone-600 dark:text-gray-300 text-sm">
              <p className="mb-2">
                Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrarle publicidad relacionada con sus preferencias mediante el análisis de sus hábitos de navegación.
              </p>
              <p className="mb-2">
                El responsable del tratamiento es devagile.tools. Puede obtener más información sobre el tratamiento de sus datos personales en nuestra{' '}
                <Link to="/privacy-policy" className="text-blue-600 dark:text-blue-400 hover:underline">
                  Política de Privacidad
                </Link>.
              </p>
              <p>
                Puede configurar sus preferencias de cookies en cualquier momento haciendo clic en el botón "Configurar cookies".
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={openCookieSettings}
                className="bg-stone-200 hover:bg-stone-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-stone-700 dark:text-gray-300 px-4 py-2 rounded-lg text-sm flex items-center justify-center gap-2"
              >
                <Settings size={16} />
                Configurar cookies
              </button>
              <button
                onClick={declineCookies}
                className="bg-stone-200 hover:bg-stone-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-stone-700 dark:text-gray-300 px-4 py-2 rounded-lg text-sm"
              >
                Rechazar todas
              </button>
              <button
                onClick={acceptCookies}
                className="bg-amber-500 hover:bg-amber-600 text-white px-4 py-2 rounded-lg text-sm"
              >
                Aceptar todas
              </button>
            </div>
          </div>

          {showDetails && (
            <div className="mt-4 p-4 bg-white dark:bg-gray-700 rounded-lg">
              <h3 className="text-lg font-semibold mb-3">Configuración de cookies</h3>
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-medium">Cookies técnicas</h4>
                    <p className="text-sm text-gray-600 dark:text-gray-300">Necesarias para el funcionamiento del sitio</p>
                  </div>
                  <input 
                    type="checkbox" 
                    checked={preferences.technical}
                    disabled
                    className="form-checkbox" 
                  />
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-medium">Cookies analíticas</h4>
                    <p className="text-sm text-gray-600 dark:text-gray-300">Nos ayudan a mejorar nuestros servicios</p>
                  </div>
                  <input 
                    type="checkbox" 
                    checked={preferences.analytics}
                    onChange={() => handlePreferenceChange('analytics')}
                    className="form-checkbox" 
                  />
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-medium">Cookies de publicidad</h4>
                    <p className="text-sm text-gray-600 dark:text-gray-300">Para mostrar publicidad personalizada</p>
                  </div>
                  <input 
                    type="checkbox" 
                    checked={preferences.advertising}
                    onChange={() => handlePreferenceChange('advertising')}
                    className="form-checkbox" 
                  />
                </div>
              </div>
              <div className="mt-4 flex justify-end gap-2">
                <button
                  onClick={() => setShowDetails(false)}
                  className="px-4 py-2 text-sm text-gray-600 dark:text-gray-300 hover:underline"
                >
                  Cerrar
                </button>
                <button
                  onClick={savePreferences}
                  className="px-4 py-2 text-sm bg-amber-500 hover:bg-amber-600 text-white rounded-lg"
                >
                  Guardar preferencias
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CookieBanner; 